import { render, staticRenderFns } from "./knowledge-dialog-add.vue?vue&type=template&id=1789471e"
import script from "./knowledge-dialog-add.vue?vue&type=script&lang=js"
export * from "./knowledge-dialog-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports